import { isPhone } from 'base/utils/client';

export const theme = {
    useRem: true,
    supportApp: true,
    siteSpace: isPhone ? 16 : 20,
    wrapperWidth: isPhone ? 375 : 1200,
    buttonTypes: ['default', 'primary', 'dashed', 'a', 'b', 'c', 'd', 'e', 'text', 'link', 'base', 'no-style'],
    placeholderColor: '#f4f4f4',
    defaultBgColor: '#FBFBFB',
    emptyIcons: {
        search: 'asset/width-304/picture/34995fe1fd12de526c1ef89a582b6ff3.png',
        order: 'asset/width-304/picture/5723c2b5d597b9cc13ad6fee0e8fc557.png',
        filter: 'asset/width-304/picture/82cb271fc9127dad004c717a69fd289e.png',
        error: 'asset/width-304/picture/daa54f7b6664ab00d1b040557d3aa4b7.png',
        coupon: 'asset/width-304/picture/bcd6fef86e7b0aa0c3e7f437f8bbcb59.png',
        comment: 'asset/width-304/picture/c2255845ff133e5098e44d17fc82b962.png',
        cart: 'asset/width-304/picture/c6af224a4cc0d1cd355f4a74fe524fb2.png',
        address: 'asset/width-304/picture/073c265116851d928e5fb9ea35ed2597.png',
    }
}